export class LabParameterGroup {
    labParameterDetailId: number;
    labParameterHeaderId: number;
    parameterName: string;
    gender: string;
    fromAge?: number;
    fromAgeType: string;
    toAge?: number;
    toAgeType: string;
    minValue: number;
    maxValue: number;
    minCriticalValue: string;
    maxCriticalValue: string;
    unitId?: number;
    unitName: string;
    rangeText: string;
}